// extracted by mini-css-extract-plugin
module.exports = {"section":"E_section__YUpzf"};